class EdenBrooksGlobalJs {
    slide2Init = [];
    slickInitConfigs = {};
    carousels = {};
    constructor() {
        this.init();
    }

    init() {
        this.#initializeSlick();
    }

    #initializeSlick() {
        document.addEventListener('DOMContentLoaded', () => {
            if ( this.slide2Init.length > 0 ) {
                this.slide2Init.forEach( sliderId => {
                    const sliderEl = document.querySelector(`#${sliderId}`);
                    const sliderElement = jQuery(sliderEl);
                    const sliderConfig = sliderElement.data('config');

                    delete sliderConfig.slideId;
                    sliderConfig.appendArrows = jQuery(`#${sliderId}-nav`);

                    sliderElement.on('init', function(evt, slick) {
                        slick.$slider.removeAttr('style');
                        slick.$slider.parent().removeAttr('style');

                        if (sliderId.startsWith('our_development_slider')) {
                            setTimeout(() => {
                                slick.$slider.find('.edenbrooks-our-development-slider-item').each(function(index, slideElement){
                                    jQuery(slideElement).removeAttr('style');
                                });
                                jQuery(`#${sliderId}-nav`).removeAttr('style');
                            }, 50);
                        }
                    });

                    this.slickInitConfigs[sliderId] = sliderConfig;
                    this.carousels[sliderId] = sliderElement.slick(sliderConfig);
                });
            }
        });
    }

    filterProperties(sliderId, element, evt) {
        evt.preventDefault();
        const setThisIsotopeAsActive = (el) => {
            let parentEl = el.parentNode;
            let isotopes = parentEl.querySelectorAll('.edenbrooks-our-development-slider-isotope-btn');
            if ( isotopes.length > 0 ) {
                [...isotopes].forEach(isotope => {
                    isotope.classList.remove('active');
                });

                el.classList.add('active');
            }
        }

        const filterType = element.getAttribute('data-toggle');

        if ( this.carousels.hasOwnProperty(sliderId) ) {
            setThisIsotopeAsActive(element);
            const sliderElement = this.carousels[sliderId];
            const slickConfig = this.slickInitConfigs[sliderId];

            jQuery.ajax({
                url: ebrooksAppJs.ajax_url,
                type: 'GET',
                data: {
                    action: 'filter_development_section',
                    data: filterType
                },
                beforeSend: function(xhr) {
                    jQuery(sliderElement).addClass('loading');
                },
                success: (response) => {
                    let elements = response.properties;
                    jQuery(sliderElement).slick('unslick');

                    jQuery(sliderElement).html('');

                    jQuery.each(elements, function(index, child) {
                        jQuery(sliderElement).append(child);
                    });

                    this.carousels[sliderId] = jQuery(sliderElement).slick(slickConfig);

                    let visibleSlides = elements.length;

                    if (visibleSlides < 3) {
                        let _updatedVisibleSlides = visibleSlides === 2 ? 3 : visibleSlides;
                        jQuery(sliderElement).removeClass(`edenbrooks-slider-filter--ic${_updatedVisibleSlides}`);
                        jQuery(sliderElement).addClass('edenbrooks-slider-filtered').addClass(`edenbrooks-slider-filter--ic${visibleSlides}`);

                        jQuery(sliderElement).slick('slickSetOption', {
                            centerMode: false,
                            centerPadding: '0px',
                            slidesToShow: _updatedVisibleSlides,
                            infinite: false,
                        }, true);
                    } else {
                        jQuery(sliderElement).removeClass(`edenbrooks-slider-filter--${slickConfig.slidesToShow}`);
                        jQuery(sliderElement).addClass('edenbrooks-slider-filtered').addClass(`edenbrooks-slider-filter--ic${slickConfig.slidesToShow}`);

                        jQuery(sliderElement).slick('slickSetOption', {
                            centerMode: slickConfig.centerMode,
                            centerPadding: slickConfig.centerPadding,
                            slidesToShow: slickConfig.slidesToShow,
                            infinite: slickConfig.infinite,
                        }, true);
                    }

                    setTimeout(() => {
                        jQuery(sliderElement).removeClass('loading');
                    }, 50);
                },
                error: function(xhr, status, error) {
                    console.log('Error: ' + error);
                    jQuery(sliderElement).removeClass('loading');
                }
            });
        }
    }
}
window.$EdenBrooksGlobalJs = new EdenBrooksGlobalJs();